// extracted by mini-css-extract-plugin
export var hasAltImage = "HoverImageSwap-module--hasAltImage--5df7f";
export var hover = "HoverImageSwap-module--hover--51bd9";
export var imgContainer = "HoverImageSwap-module--imgContainer--e29f4";